import { useUnifiedStore } from "./StoreContext";
import { AuthService } from "../services/AuthService";
export const GEO_DIAL_CODES = { IN: "+91" };
export function verifiedPricingCountry(state) {
    if (!state.otpVerified)
        return null;
    if (state.otpChannel === "email") {
        const patient = state.patientTab === "existing" ? state.selectedPatient : null;
        return patient?.countryCode?.trim() || null;
    }
    return state.countryCode.trim() || null;
}
export function pricingCountry(verified, networkCountry) {
    if (!verified)
        return networkCountry;
    const networkDialCode = networkCountry
        ? GEO_DIAL_CODES[networkCountry.toUpperCase()]
        : undefined;
    return networkDialCode === verified ? networkCountry : verified;
}
export function usePricingCountry() {
    const verified = useUnifiedStore(verifiedPricingCountry);
    return pricingCountry(verified, AuthService.getGeoLocation()?.country || null);
}
